// Примеры результатов взаимодействия с AI Ассистентом
// Создано с учетом опыта внедрения AI в госуправление

import { AIResult } from "@/types/aiAssistant";

export const aiResultsExamples: AIResult[] = [
  {
    id: "1",
    type: "report",
    title: "Справка: Криминальная обстановка в г. Атырау",
    content: `АНАЛИТИЧЕСКАЯ СПРАВКА
по криминальной обстановке в г. Атырау
за период январь 2025 года

ОБЩИЕ ПОКАЗАТЕЛИ:
• Всего зарегистрировано преступлений: 19,056 (+6.2% к прошлому году)
• Преступность на 100 тыс. населения: 1,245 (выше среднего по РК)
• Раскрываемость: 78.5% (+1.2 п.п. к прошлому периоду)

СТРУКТУРА ПРЕСТУПНОСТИ:
• Имущественные преступления: 9,320 (48.9%) - кражи, мошенничества
• Преступления против личности: 3,820 (20.0%) - насильственные преступления
• Экономические преступления: 2,850 (15.0%)
• Транспортные преступления: 2,066 (10.8%)

ПРОБЛЕМНЫЕ ЗОНЫ:
1. Медеуский район - рост на 12.5% (имущественные преступления)
2. Турксибский район - рост на 9.8% (преступления против личности)
3. Алмалинский район - рост на 7.2% (экономические преступления)

РЕКОМЕНДАЦИИ:
• Усилить патрулирование в Медеуском и Турксибском районах
• Провести профилактические мероприятия по имущественным преступлениям
• Усилить работу с группами риска в проблемных районах

Подготовлено: AI Ассистент ведомства
Дата: 15.01.2025 14:30`,
    timestamp: new Date(2025, 0, 15, 14, 30),
    request: "Сделай справку по криминальной обстановке в г. Атырау",
    metadata: {
      region: "г. Атырау",
      period: "Январь 2025",
      crimeCount: 19056,
      growth: 6.2,
    },
  },
  {
    id: "2",
    type: "schedule_check",
    title: "Проверка графика - завтра (16.01.2025)",
    content: `ПРОВЕРКА СВОБОДНОГО ВРЕМЕНИ

Дата: 16 января 2025 года (четверг)

ДОСТУПНОЕ ВРЕМЯ:
✅ 14:00 - 16:00 (2 часа) - СВОБОДНО
✅ 17:00 - 18:00 (1 час) - СВОБОДНО

ЗАНЯТОЕ ВРЕМЯ:
• 09:00 - 10:30 - Совещание с заместителями
• 11:00 - 12:30 - Встреча с акимом города Атырау
• 13:00 - 13:45 - Обед
• 16:30 - 17:00 - Рабочий звонок

ВЫВОД:
У вас есть свободное окно с 14:00 до 16:00 (2 часа), что достаточно для встречи или совещания.

Рекомендация: Запланировать важные встречи на это время.

Проверено: AI Ассистент ведомства
Дата проверки: 15.01.2025 15:45`,
    timestamp: new Date(2025, 0, 15, 15, 45),
    request: "Проверь мой график на завтра",
    metadata: {
      date: "16.01.2025",
      hasTime: true,
      timeSlot: "14:00-16:00",
      duration: "2 часа",
    },
  },
  {
    id: "3",
    type: "command",
    title: "Сообщение отправлено: Иванов И.И.",
    content: `КОМАНДА ВЫПОЛНЕНА

Тип: Отправка сообщения
Получатель: Иванов Иван Иванович
Должность: Аким города Атырау

ТЕКСТ СООБЩЕНИЯ:
"Иван Иванович, добрый день. Прошу обратить внимание на рост преступности в Медеуском районе на 12.5%. Необходимо усилить профилактические мероприятия. Прошу подготовить план действий до 20.01.2025."

СТАТУС: ✅ Сообщение доставлено
Время отправки: 15.01.2025 16:20
Канал: Внутренняя система связи

СОХРАНЕНО В ИСТОРИИ ВЗАИМОДЕЙСТВИЯ`,
    timestamp: new Date(2025, 0, 15, 16, 20),
    request: "Напиши Иванову что ему надо обратить внимание на рост преступности в Медеуском районе",
    metadata: {
      recipient: "Иванов И.И.",
      recipientPosition: "Аким города Атырау",
      type: "message",
      status: "delivered",
    },
  },
  {
    id: "4",
    type: "report",
    title: "Справка: Защита бизнеса - общая ситуация",
    content: `АНАЛИТИЧЕСКАЯ СПРАВКА
по защите бизнеса и контролю прав предпринимателей
за период декабрь 2024 - январь 2025

ОБЩИЕ ПОКАЗАТЕЛИ:
• Всего жалоб от предпринимателей: 1,295 (+8.3% к прошлому периоду)
• Проведено проверок: 5,560 (+5.1%)
• Выявлено нарушений прав бизнеса: 282 (+12.8%)
• Отменено незаконных актов: 145 (после вмешательства ведомства)

ПО РЕГИОНАМ:
1. г. Атырау - 245 жалоб, 38 повторных (15.5%)
2. Жылыойский район - 198 жалоб, 28 повторных (14.1%)
3. Курмангазинский район - 156 жалоб, 22 повторных (14.1%)

ПО ОТРАСЛЯМ:
• Торговля - 420 жалоб (32.5%)
• Производство - 380 жалоб (29.4%)
• Строительство - 280 жалоб (21.7%)

ПО ОРГАНАМ:
• Налоговые органы - 1,240 проверок, 85 нарушений
• Финконтроль - 890 проверок, 62 нарушения
• Полиция - 1,560 проверок, 45 нарушений

ЭФФЕКТИВНОСТЬ РЕАГИРОВАНИЯ:
• Протесты: 158 (эффективность 89.9%)
• Представления: 232 (эффективность 85.3%)
• Иски: 105 (эффективность 83.8%)

ВЫВОДЫ:
• Наблюдается рост жалоб, особенно в сфере торговли
• Высокая доля повторных жалоб указывает на системные проблемы
• Эффективность реагирования ведомства остается высокой

РЕКОМЕНДАЦИИ:
• Усилить контроль за налоговыми проверками
• Проработать системные проблемы в торговой сфере
• Усилить профилактическую работу с контролирующими органами

Подготовлено: AI Ассистент ведомства
Дата: 15.01.2025 10:15`,
    timestamp: new Date(2025, 0, 15, 10, 15),
    request: "Подготовь справку по защите бизнеса",
    metadata: {
      period: "Декабрь 2024 - Январь 2025",
      complaints: 1295,
      inspections: 5560,
      violations: 282,
    },
  },
  {
    id: "5",
    type: "schedule_check",
    title: "Проверка графика - сегодня (15.01.2025)",
    content: `ПРОВЕРКА СВОБОДНОГО ВРЕМЕНИ

Дата: 15 января 2025 года (среда)

ЗАНЯТОЕ ВРЕМЯ:
• 09:00 - 10:00 - Ежедневное совещание
• 10:30 - 12:00 - Встреча с региональными сотрудниками
• 14:00 - 15:30 - Рабочая встреча по преступности
• 16:00 - 17:00 - Внутреннее совещание

ДОСТУПНОЕ ВРЕМЯ:
❌ 14:00 - 15:00 - ЗАНЯТО (встреча по преступности)

ВЫВОД:
К сожалению, у вас нет свободного времени сегодня в 14:00. 
В это время запланирована рабочая встреча по преступности (14:00-15:30).

АЛЬТЕРНАТИВЫ:
• 12:00 - 13:00 (1 час) - свободно
• 13:00 - 14:00 (1 час) - свободно (обеденное время)
• 17:00 - 18:00 (1 час) - свободно

Проверено: AI Ассистент ведомства
Дата проверки: 15.01.2025 11:30`,
    timestamp: new Date(2025, 0, 15, 11, 30),
    request: "Проверь мой график на сегодня, есть ли время в 14:00",
    metadata: {
      date: "15.01.2025",
      hasTime: false,
      conflict: "Рабочая встреча по преступности (14:00-15:30)",
      alternatives: ["12:00-13:00", "13:00-14:00", "17:00-18:00"],
    },
  },
  {
    id: "6",
    type: "report",
    title: "Краткая сводка по всем модулям за сегодня",
    content: `КРАТКАЯ СВОДКА
по всем направлениям работы
15 января 2025 года

ПРЕСТУПНОСТЬ:
• Зарегистрировано: 1,050 преступлений (-2.1% к вчера)
• Раскрываемость: 79.8% (+0.5 п.п.)
• Проблемные регионы: г. Атырау (+6.2%), Жылыойский район (+4.8%)

РЕЗОНАНСНЫЕ СОБЫТИЯ:
• Всего событий: 12 (3 новых за сегодня)
• В работе: 8 событий
• Просрочено: 1 событие (требует внимания)

ИСПОЛНЕНИЕ НАКАЗАНИЙ:
• Учреждения УИС: загрузка 94.2% (в норме)
• Нарушений режима: 3 (в пределах нормы)
• УДО: 2,480 человек (стабильно)

ЗАЩИТА БИЗНЕСА:
• Новых жалоб: 18 (+2 к вчера)
• Проверок: 45
• Отменено актов: 3

ИНВЕСТОРЫ И ПРОЕКТЫ:
• Проектов под контролем: 22
• С рисками: 3 проекта
• Жалоб инвесторов: 2 (в работе)

ОБРАЩЕНИЯ ГРАЖДАН:
• Поступило: 930 (+25 к вчера)
• Просрочено: 93 (10.0%)
• Принято мер: 283 (30.4%)

КАДРОВАЯ ПОЛИТИКА:
• Назначений: 2
• Дисциплинарных взысканий: 1
• В сети: 10 из 12 руководителей

КРИТИЧЕСКИЕ МОМЕНТЫ:
⚠️ Рост обращений граждан (+25)
⚠️ 1 просроченное резонансное событие
⚠️ 3 проекта с рисками требуют внимания

ПОЗИТИВНЫЕ ТЕНДЕНЦИИ:
✅ Снижение преступности на 2.1%
✅ Раскрываемость выросла до 79.8%
✅ Стабильная ситуация в УИС

Подготовлено: AI Ассистент ведомства
Дата: 15.01.2025 18:00`,
    timestamp: new Date(2025, 0, 15, 18, 0),
    request: "Дай краткую сводку по всем модулям за сегодня",
    metadata: {
      period: "15.01.2025",
      modules: ["Преступность", "Резонансные события", "Исполнение наказаний", "Защита бизнеса", "Инвесторы", "Обращения", "Кадры"],
    },
  },
  {
    id: "7",
    type: "report",
    title: "Топ-5 проблемных регионов",
    content: `РЕЙТИНГ РЕГИОНОВ
по совокупности проблемных показателей
за период январь 2025

ТОП-5 ПРОБЛЕМНЫХ РЕГИОНОВ:

1. АЛМАТЫ
   Индекс проблемности: 8.5 (высокий)
   • Преступность: +6.2% (19,056 преступлений)
   • Обращения граждан: 12,500 (+8.1%)
   • Жалобы бизнеса: 245 (+12.3%)
   • Резонансные события: 8
   Требует: Усиления профилактики, работы с обращениями

2. АСТАНА
   Индекс проблемности: 7.8 (высокий)
   • Преступность: +4.8% (14,613 преступлений)
   • Обращения граждан: 11,200 (+6.5%)
   • Жалобы бизнеса: 198 (+9.2%)
   • Резонансные события: 6
   Требует: Контроля преступности, работы с бизнесом

3. ШЫМКЕНТ
   Индекс проблемности: 6.5 (средний)
   • Преступность: +3.1% (5,340 преступлений)
   • Обращения граждан: 6,800 (+4.2%)
   • Жалобы бизнеса: 156 (+7.8%)
   • Резонансные события: 4
   Требует: Мониторинга ситуации

4. АЛМАТИНСКАЯ ОБЛАСТЬ
   Индекс проблемности: 5.9 (средний)
   • Преступность: -1.4% (4,720 преступлений) ✅
   • Обращения граждан: 5,200 (+2.1%)
   • Жалобы бизнеса: 142 (+5.6%)
   Требует: Поддержания положительной динамики

5. КАРАГАНДИНСКАЯ ОБЛАСТЬ
   Индекс проблемности: 5.2 (средний)
   • Преступность: +2.0% (5,010 преступлений)
   • Обращения граждан: 4,800 (+3.5%)
   • Жалобы бизнеса: 128 (+4.9%)
   Требует: Стабилизации показателей

МЕТОДОЛОГИЯ:
Индекс проблемности рассчитывается на основе:
- Роста преступности
- Количества обращений граждан
- Жалоб бизнеса
- Резонансных событий
- Других факторов риска

РЕКОМЕНДАЦИИ:
• Приоритетное внимание г. Атырау и Астане
• Разработать целевые программы для проблемных регионов
• Усилить координацию с региональными ведомствоми

Подготовлено: AI Ассистент ведомства
Дата: 15.01.2025 16:45`,
    timestamp: new Date(2025, 0, 15, 16, 45),
    request: "Покажи топ-5 регионов с наибольшими проблемами",
    metadata: {
      period: "Январь 2025",
      regions: ["г. Атырау", "Жылыойский район", "Курмангазинский район", "Махамбетский район", "Исатайский район"],
      topRegion: "г. Атырау",
    },
  },
  {
    id: "8",
    type: "command",
    title: "Сообщение отправлено: Петров П.П.",
    content: `КОМАНДА ВЫПОЛНЕНА

Тип: Отправка сообщения
Получатель: Петров Петр Петрович
Должность: Заместитель акима области

ТЕКСТ СООБЩЕНИЯ:
"Петр Петрович, прошу подготовить аналитическую справку по росту обращений граждан в г. Атырау. Особое внимание обратить на причины роста на 8.1%. Срок: до 18.01.2025."

СТАТУС: ✅ Сообщение доставлено
Время отправки: 15.01.2025 17:10
Канал: Внутренняя система связи

СОХРАНЕНО В ИСТОРИИ ВЗАИМОДЕЙСТВИЯ`,
    timestamp: new Date(2025, 0, 15, 17, 10),
    request: "Напиши Петрову просьбу подготовить справку по росту обращений в г. Атырау",
    metadata: {
      recipient: "Петров П.П.",
      recipientPosition: "Заместитель акима области",
      type: "message",
      status: "delivered",
    },
  },
  {
    id: "9",
    type: "query",
    title: "Вопрос: Статистика по раскрываемости",
    content: `ОТВЕТ НА ЗАПРОС

Вопрос: "Какая раскрываемость преступлений по РК?"

ОТВЕТ:
Средняя раскрываемость преступлений по Республике Казахстан составляет 79.8% (+1.2 п.п. к прошлому периоду).

ПО РЕГИОНАМ:
• Жылыойский район - 82.3% (выше среднего)
• Исатайский район - 81.1% (выше среднего)
• Махамбетский район - 79.8% (на уровне среднего)
• г. Атырау - 78.5% (ниже среднего)
• Курмангазинский район - 75.2% (требует внимания)

ТЕНДЕНЦИИ:
✅ Общая динамика положительная - рост на 1.2 п.п.
⚠️ Курмангазинский район требует усиления работы по раскрываемости

Дополнительная информация доступна в модуле "Преступность".

Ответ подготовлен: AI Ассистент ведомства
Дата: 15.01.2025 17:30`,
    timestamp: new Date(2025, 0, 15, 17, 30),
    request: "Какая раскрываемость преступлений по РК?",
    metadata: {
      topic: "Раскрываемость",
      average: "79.8%",
      trend: "positive",
    },
  },
  {
    id: "10",
    type: "query",
    title: "Вопрос: Количество обращений граждан",
    content: `ОТВЕТ НА ЗАПРОС

Вопрос: "Сколько обращений граждан поступило за сегодня?"

ОТВЕТ:
За сегодня (15.01.2025) поступило 930 обращений граждан (+25 к вчерашнему дню).

ПО КАНАЛАМ:
• eOtinish - 680 обращений (73.1%)
• Телефон 109 - 150 обращений (16.1%)
• Личный приём - 100 обращений (10.8%)

ПО ТЕМАТИКЕ:
• ЖКХ - 230 обращений (24.7%)
• Соцсфера - 190 обращений (20.4%)
• Полиция - 160 обращений (17.2%)
• Суды - 140 обращений (15.1%)
• Медицина - 120 обращений (12.9%)
• Прочие - 90 обращений (9.7%)

СТАТУС РАССМОТРЕНИЯ:
• В работе - 650 обращений
• Просрочено - 93 обращения (10.0%)
• Принято мер - 283 обращения (30.4%)

ВЫВОД:
Наблюдается рост обращений на 25 единиц. Требуется обратить внимание на просроченные обращения (93).

Ответ подготовлен: AI Ассистент ведомства
Дата: 15.01.2025 18:15`,
    timestamp: new Date(2025, 0, 15, 18, 15),
    request: "Сколько обращений граждан поступило за сегодня?",
    metadata: {
      topic: "Обращения граждан",
      count: 930,
      period: "15.01.2025",
    },
  },
];

